export const yaMetrica = (id, params = {}) => {
    if (typeof window === 'undefined' || typeof window.ym === 'undefined' || !id) {
        return;
    }

    try {
        window.ym(87782760, 'reachGoal', id, params);
    } catch (error) {
        console.error(error);
    }
};

export default (ctx, inject) => {
    inject('ym', yaMetrica);
};
